import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    page: 0,
    navDrawer: false
  },
  mutations: {
    nextPage(state) {
      if (state.page === 2) {
        state.page = 0;
      } else {
        state.page += 1;
      }
    },
    previousPage(state) {
      if (state.page === 0) {
        state.page = 2;
      } else {
        state.page -= 1;
      }
    },
    navDrawerToggle(state) {
      state.navDrawer = !state.navDrawer;
    }
  },
  actions: {},
  modules: {}
});
